var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"iframe-container"},[_c('div',{staticClass:"tally-iframe"},[_c('iframe',{attrs:{"data-tally-src":"https://tally.so/embed/wz1R5Z?hideTitle=1&transparentBackground=1&dynamicHeight=1","loading":"lazy","width":"100%","height":"100%","frameborder":"0","marginheight":"0","marginwidth":"0","title":"슈퍼멤버스 구독 완료"}})])])])
}]

export { render, staticRenderFns }